export default __webpack_public_path__ + "static/tag-do-3-light-408440c55eb3c9fb55439c306b99e7173f5ee42e3389736fe81377775cd555e2.png";